module.exports = __webpack_public_path__ + "static/img/v10.caa7fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v10.jpg
// module id = Y+S4
// module chunks = 1